import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FeedbackComponent } from './pages/feedback.component';
import {SuccessComponent} from "./pages/success/success.component";
import { ExpiredComponent } from './pages/expired/expired.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../scanner/scanner.module').then(m => m.ScannerModule)
  },
  {
    path: ':companyCode/:refNum',
    component: FeedbackComponent,
  },
  {
    path: ':companyCode/:refNum/expired',
    component: ExpiredComponent,
  },
  {
    path: ':companyCode/:refNum/success',
    component: SuccessComponent,
  },
  {
    path: ':companyCode/:refNum/:section',
    component: FeedbackComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class FeedbackRoutingModule {}
